import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../services/api';
import useAuthStore from '../store/authStore';
import toast from 'react-hot-toast';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { setAuth } = useAuthStore();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await authAPI.login(email, password);
      setAuth(data.user, data.token);
      toast.success(`Welcome back, ${data.user.full_name}!`);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--accent)', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: 4 }}>Mich-CA</div>
          <div style={{ fontSize: 28, fontWeight: 800 }}>Schedule Portal</div>
          <div style={{ fontSize: 13, color: 'var(--mid)', marginTop: 6 }}>2026 Season · Michigan Cricket Association</div>
        </div>

        <div className="card" style={{ padding: 28 }}>
          <form onSubmit={handleSubmit}>
            <div className="field">
              <label className="field-label">Email Address *</label>
              <input className="input" type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="your@email.com" required autoFocus />
            </div>
            <div className="field">
              <label className="field-label">Password *</label>
              <input className="input" type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password" required />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}
              style={{ width: '100%', justifyContent: 'center', marginTop: 8, padding: '11px' }}>
              {loading ? '⟳ Signing in...' : '→ Sign In'}
            </button>
          </form>
        </div>

        <p style={{ textAlign: 'center', fontSize: 12, color: 'var(--dim)', marginTop: 16 }}>
          Don't have access? Contact your MichCA administrator.
        </p>
      </div>
    </div>
  );
}
